/*
https://www.facebook.com/
https://www.instagram.com/?hl=en
https://twitter.com/?lang=en

* Copyright (c) 2021. by N-Ach (Pvt) Ltd
*
* ╔═╗ ╔╗    ╔═══╗  ╔╗
* ║║╚╗║║    ║╔═╗║  ║║
* ║╔╗╚╝║    ║║ ║╠══╣╚═╗
* ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
* ║║ ║║║╚══╝║╔═╗║╚═╣║║║
* ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
*
* All rights reserved.
*
* This software is the confidential and proprietary information
* of N-Ach (Pvt) Ltd. ("Confidential Information"). You
* shall not disclose such Confidential Information and shall use
* it only in accordance with the terms of the license agreement
* you entered into with N-Ach (Pvt) Ltd.
*
*
* @Author Shalani Chethana
* @Date 18/03/2025
*/

import React from 'react';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import useScrollAnimation from "../../hooks/scrollAnimation";
import Styles from "./vision.module.css";

const VisionMission = () => {
  useScrollAnimation(".visionContectBox");

  return (
    <div className={Styles.visionMissionContainer}>
      <div className={Styles.visionBox}>
        <Box className={`${Styles.visionContectBox} ${Styles.fadeUp }`  }>
          <Typography variant='h3' className={Styles.visionMisionHeader}>Our Vision</Typography>
          <Typography variant='h6' className={Styles.visionMisionBody} >Empowering Businesses to Thrive towards their Need for Achievement..</Typography>
        </Box>
        <div className={Styles.visionImgCom}>
          <Box className={Styles.visionContectBoxMobile}>
            <Typography variant='h3' className={Styles.visionMisionHeader}>Our Vision</Typography>
            <Typography variant='h6' className={Styles.visionMisionBody} >Empowering Businesses to Thrive towards their Need for Achievement..</Typography>
          </Box>
        </div>

      </div>
      <div className={Styles.visionBox}>
        <div className={Styles.missionImgCom}>
          <Box className={Styles.visionContectBoxMobile}>
            <Typography variant='h3' className={Styles.visionMisionHeader}>Our Mission</Typography>
            <Typography variant='h6' className={Styles.visionMisionBody} >At N-ACH, we are dedicated to empowering businesses with smart, secure, and data-driven solutions. We pledge to equip our clients with powerful reporting and analytics tools, providing valuable insights to support informed decision making. Our commitment extends to reducing administrative burdens for businesses, enhancing efficiency across all operations, and guiding our customers on their journey toward growth and success..</Typography>
          </Box>
        </div>
        <Box className={Styles.visionContectBox}>
          <Typography variant='h3' className={Styles.visionMisionHeader}>Our Mission</Typography>
          <Typography variant='h6' className={Styles.visionMisionBody} >At N-ACH, we are dedicated to empowering businesses with smart, secure, and data-driven solutions. We pledge to equip our clients with powerful reporting and analytics tools, providing valuable insights to support informed decision making. Our commitment extends to reducing administrative burdens for businesses, enhancing efficiency across all operations, and guiding our customers on their journey toward growth and success..</Typography>
        </Box>

      </div>
    </div>
  );
};

export default VisionMission;